import { Box, Group, Paper } from "@mantine/core";

import classes from "./PhoneFrame.module.css";

export function PhoneFrame({ children }) {
  return (
    <Paper
      p={0}
      radius={54}
      pos="relative"
      style={{ borderWidth: 10 }}
      withBorder
      className={classes.boxScreen}
    >
      <Box className={classes.btnVolumeUp} />
      <Box className={classes.btnVolumeDown} />
      <Box className={classes.btnLock} />

      <Group justify="space-between" my="sm">
        <div></div>
        <Box className={classes.boxCamera} />
        <div></div>
      </Group>

      {children}

      <Group justify="space-between" my="sm">
        <div></div>
        <Box w={120} h={6} bg="gray.8" style={{ borderRadius: 18 }} />
        <div></div>
      </Group>
    </Paper>
  );
}
